<template>
  <div class="flex">
    <MainMenu class="side-menu-left" :selectTab="selectTab" :admin_fit20="this._data" :fit20="fit20"></MainMenu>
    <Content class="content" :fit20="fit20" :selectTab="selectTab" :admin_fit20="this._data" :saveBlock="saveBlock"
      :cancelEditing="cancelEditing">
    </Content>
  </div>
</template>

<script>
import MainMenu from './MainMenu';
import Content from './Content.vue';
export default {
  name: 'Admin',
  components: {
    MainMenu,
    Content
  },
  props: ["selectTab", "fit20", "formatDate", "saveBlock", "cancelEditing"],
  data() {
    return {
      studio: {},
      machines: [],
      machine: {},
      members: [],
      member: {},
      users: [],
      user: {}
    };
  },
  async created() {
    this.selectTab('#admin_studios');
  },
};
</script>

<style>
.admin-header-container {
  height: 130px;
  background-color: white;
}

.admin-header {
  height: 130px;
  width: 75%;
  padding-right: 20px;
  background-color: white;
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  z-index: 99;
}

.admin-header .img-container {
  text-align: right;
}

.admin-header-sec {
  padding: 10px 5px;
}

.admin-title-sec {
  color: var(--fit20-blue);
}

.side-menu-left {
  width: 25%;
  max-width: 200px;
}

.content {
  flex: 1;
}
</style>
